module.exports = __webpack_public_path__ + "img/box_gift_icon.2da2dbff.svg";